module.exports = __webpack_public_path__ + "static/media/chart.3f0d90ba.png";